import { ApexAutomationSearch } from './ApexAutomationSearch';
import { PeriscopeApexClass } from '.';
import { PeriscopeList } from '..';
import React, { useCallback } from 'react';
import { usePeriscopeActions, useQueryResource } from '@hooks';
export const ApexAutomationList = ({ parentIndex, uri }) => {
    const { openPeriscope } = usePeriscopeActions();
    const { loading, resource, updateParams } = useQueryResource({ uri });
    const renderList = useCallback((items) => items === null || items === void 0 ? void 0 : items.map((item) => {
        const { displayName, sonarObjectId, sonarObjectType } = item;
        const handleClick = () => {
            openPeriscope({
                id: sonarObjectId,
                name: displayName,
                openedFromIndex: parentIndex,
                type: sonarObjectType
            });
        };
        return (React.createElement(PeriscopeApexClass, { apex: item, key: sonarObjectId, onApexClick: handleClick, sonarObjectType: sonarObjectType }));
    }), [openPeriscope, parentIndex]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ApexAutomationSearch, { onChange: updateParams }),
        React.createElement(PeriscopeList, { list: renderList, loading: loading, results: resource !== null && resource !== void 0 ? resource : [] })));
};
